export default __webpack_public_path__ + "static/media/services_photography.d1f60fbf.jpg";